export default {
  "widget.defaultTitle": "チャットで相談",
  "widget.defaultSubtitle": "お気軽にご相談ください",
  "widget.defaultGreeting": "こんにちは！本日はどのようなご用件でしょうか？",
  "chat.close": "チャットを閉じる",
  "chat.open": "チャットを開く",
  "chat.expand": "チャットを拡大",
  "chat.collapse": "チャットを縮小",
  "chat.conversationEnded": "この会話は終了しました",
  "chat.startNew": "新しい会話を始める",
  "chat.poweredBy": "Powered by",
  "chat.conversationClosed": "会話終了",
  "chat.aiLabel": "AIアシスタント",
  "input.placeholder": "メッセージを入力...",
  "input.send": "メッセージを送信",
  "error.sendFailed": "メッセージを送信できませんでした。しばらくしてからもう一度お試しください。",
  "error.messageTooLong": "メッセージが長すぎます。短くしてもう一度お試しください。",
  "chat.teamMember": "チームメンバー",
  "chat.agentJoined": "{name}がチャットに参加しました",
  "chat.agentLeft": "{name}がチャットから退出しました",
  "chat.agentReturnedToAi":
    "{name}がチャットから退出しました。再びAIアシスタントがお手伝いします。",
  "availability.open": "営業中",
  "availability.backAt": "{when}に再開",
  "availability.closed": "現在営業時間外",
  "waiting.title": "担当者を待っています",
  "waiting.typical": "通常{time}以内に返信",
  "waiting.alerted": "チームに通知しました。",
  "waiting.closed": "チームは{when}に戻ります。それまではAIアシスタントがお手伝いします。",
  "waiting.minutes": "約{n}分",
  "waiting.hours": "約{n}時間",
  "contact.prompt":
    "メールアドレスを残していただければ、離席中でもチームの返信をメールでお送りします。",
  "contact.label": "メールアドレス",
  "contact.placeholder": "you@example.com",
  "contact.submit": "通知を受け取る",
  "contact.consent": "メールアドレスはこの会話への返信にのみ使用します。",
  "contact.saved": "ありがとうございます。チームの返信時に離席中の場合はメールでお知らせします。",
  "contact.failed": "メールアドレスを保存できませんでした。確認して再度お試しください。",
  "input.attach": "写真またはPDFを添付",
  "error.fileTooLarge": "ファイルが大きすぎます。写真とPDFは10 MBまでです。",
  "error.fileType": "写真（JPG、PNG、GIF、WebP）またはPDFを送信できます。",
  "error.fileFailed": "ファイルを送信できませんでした。別のファイルをお試しください。",
  "attachment.photo": "写真",
  "attachment.file": "ファイル",
  "attachment.sending": "送信中...",
  "error.verificationFailed": "メッセージを確認できませんでした。ページを再読み込みして、もう一度お試しください。",
  "challenge.label": "セキュリティチェック",
  "challenge.prompt": "メッセージを送信する前に、簡単なセキュリティチェックを行います。",
  "csat.defaultQuestion": "本日のサポートはいかがでしたか？",
  "csat.thankYou": "フィードバックありがとうございます！",
} as const;
